import styled from '@emotion/styled';
import { borderRadii } from '__app/spacing';
import Input from '__components/Kizen/Input';
import TableScrollContainer from '__components/Tables/ScrollContainer';

export const StyledTableToolbar = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  height: 36px;
  margin: 15px 0 20px;

  > h2 {
    text-align: center;
  }
`;

export const StyledSearchInput = styled(Input)`
  max-width: 200px;

  label {
    margin: 0;
  }

  .input-wrapper {
    margin: 0;
    background-color: var(--color-background-white);
  }

  input {
    min-width: 0;
    padding-right: 0;
  }
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  flex: 1;
  border-radius: ${borderRadii.small};
  overflow-y: hidden;
  flex-direction: column;
  position: relative;
  height: 100%;
  background-color: var(--color-background-white);
  > div {
    position: relative;
    height: 100%;
  }
`;

export const StyledPaginationWrapper = styled.div`
  width: 100%;
  flex: 0 0 45px;
  padding-top: 20px;
`;

export const StyledTableScrollContainer = styled(TableScrollContainer)`
  height: 100%;
  & .gradient-vertical-container {
    max-width: 100%;
    width: 100%;
  }
`;
